function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithoutHoles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/arrayWithHoles.js
// module id = ./node_modules/@babel/runtime/helpers/arrayWithHoles.js
// module chunks = 0